module.exports = __webpack_public_path__ + "media/images/retired_benefits_active-48964ab2.svg";